import React from "react";
import { useSelector } from "react-redux";

const ProgressBar = ({ progress }) => {
  const { chat } = useSelector((state) => state);

  const { selectedFileName, selectedFileType } = chat || {};

  return (
    <div className="progress-container">
      <div className="progress-inner">
        <div
          className="progress-bar progress-bar-striped"
          role="progressbar"
          aria-valuenow="50"
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: `${progress}%` }}
        ></div>

        <div className="progress-name">
          <span className="progress-name-inner">
            {selectedFileType[0] === "jpeg" ||
            selectedFileType[0] === "jpg" ||
            selectedFileType[0] === "png"
              ? "Processing Uploaded File..."
              : progress === 100
              ? "Processing Uploaded File..."
              : selectedFileName[0]
              ? selectedFileName[0]
              : "Processing Uploaded File..."}
          </span>
        </div>
        <div className="progress-count">{progress}%</div>
      </div>
    </div>
  );
};

export default ProgressBar;
